import { useMemo } from 'react';

import { Datepicker, Select } from '@components/common';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { renderDayWithTooltip } from '../../utils';

interface IViewNetworkConfigurationControl {
	networkElementConfigurationDates: Date[];
	selectedDate?: Date;
	selectedTimestamp: TSelectOption<number>;
	networkElementConfigurationTimestamps: TSelectOption<number>[];
	isConfigTimestampMismatch: boolean;
	isLoadingNetworkElementConfigurationDates: boolean;
	onDateChange: (date: number | null) => void;
	onTimeStampsChange: (timestamp: TSelectOption<number>) => void;
}

const ViewNetworkConfigurationControl = ({
	networkElementConfigurationDates,
	onDateChange,
	selectedDate,
	networkElementConfigurationTimestamps,
	onTimeStampsChange,
	selectedTimestamp,
	isConfigTimestampMismatch,
	isLoadingNetworkElementConfigurationDates,
}: IViewNetworkConfigurationControl) => {
	const today = useMemo(() => new Date(), []);

	const renderDayContents = useMemo(() => {
		return renderDayWithTooltip(networkElementConfigurationDates);
	}, [networkElementConfigurationDates]);

	const datesInterval = useMemo(() => {
		return networkElementConfigurationDates ? [{
			start: networkElementConfigurationDates[0],
			end: today,
		}] : undefined;
	}, [networkElementConfigurationDates, today]);

	return (
		<>
			<Datepicker
				disableFutureDates
				disableInput
				disabled={!networkElementConfigurationDates?.length}
				handleChange={onDateChange}
				highlightDates={networkElementConfigurationDates}
				includeDateIntervals={datesInterval}
				isLoading={isLoadingNetworkElementConfigurationDates}
				isMobileDevice={false}
				isTodayButton={false}
				label='Date'
				renderDayContents={renderDayContents}
				selected={selectedDate}
			/>
			{
				(!isConfigTimestampMismatch && networkElementConfigurationTimestamps.length > 1) && (
					<Select
						disabled={!networkElementConfigurationTimestamps?.length}
						handleChange={onTimeStampsChange}
						isWithoutUseForms
						label='Time'
						minWidth='140px'
						name='timestamp'
						options={networkElementConfigurationTimestamps}
						placeholder='Choose time'
						value={selectedTimestamp}
					/>
				)
			}
		</>
	);
};

export default ViewNetworkConfigurationControl;
